module.exports = __webpack_public_path__ + "img/hero.bb18f312.png";